import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import ContentCarousel from '@justpark/ui/src/components/ContentCarousel';
import Typography from '@justpark/ui/src/components/Typography';
import trustPilotReviewsLogo from '../../../static/images/landing/trustpilotCustomerReviews.png';

import styles from '../../../static/scss/components/landing/reviews.module.scss';

type Props = {
  reviews: Array<any>
};

const TrustPilotReviews = ({ reviews }: Props) => (
  <div className={styles.base}>
    <div className={styles.image}>
      <img
        src={trustPilotReviewsLogo}
        alt="Trustpilot reviews"
        width={124}
        height={115}
        loading="lazy"
      />
    </div>

    <div className={styles.reviews}>
      <ContentCarousel
        autoscroll={false}
        items={useMemo(
          () =>
            reviews.map(({ comment, sender, location }) => (
              <Link key={sender} to={location.slug}>
                <div data-cy="review-item" className={styles.reviewItem}>
                  <div className={styles.location}>
                    <Typography size="subtext">
                      <Typography bold>{sender}</Typography> JustParked at{' '}
                      <Typography color="muted">{location.title}</Typography>
                    </Typography>
                  </div>

                  <Typography size="subtext">
                    <q>{comment}</q>
                  </Typography>
                </div>
              </Link>
            )),
          [reviews]
        )}
      />
    </div>
  </div>
);

export default TrustPilotReviews;
